import { api } from '@/api/client'
import type { DeliverySlot, OrderStatus } from '@/api/orders'
import type { ProductUnit } from '@/api/suppliers'

export interface PublicOrderItem {
  id: string
  name: string
  unit: ProductUnit
  quantity: string
  confirmedQuantity: string | null
  lineNote: string | null
}

export interface PublicOrder {
  orderNumber: string
  status: OrderStatus
  businessName: string
  businessVatNumber: string | null
  businessPhone: string | null
  businessAddress: string | null
  supplierName: string
  requestedDeliveryDate: string | null
  requestedDeliverySlot: DeliverySlot | null
  requestedDeliveryTime: string | null
  orderNote: string | null
  sentAt: string | null
  confirmedAt: string | null
  deliveredAt: string | null
  cancelledAt: string | null
  items: PublicOrderItem[]
  canRespond: boolean
  canMarkDelivered: boolean
}

export interface PublicInvite {
  email: string
  supplierName: string
  customerCount: number
  orderCount: number
  alreadyClaimed: boolean
}

/**
 * Τα δημόσια endpoints δεν στέλνουν ποτέ κεφαλίδα Authorization: ο προμηθευτής
 * δεν έχει λογαριασμό και το token του συνδέσμου είναι η μόνη εξουσιοδότηση.
 */
export const publicApi = {
  order: (token: string) => api.get<PublicOrder>(`/public/orders/${token}`, { anonymous: true }),
  confirm: (token: string, note?: string) =>
    api.post<PublicOrder>(`/public/orders/${token}/confirm`, { note }, { anonymous: true }),
  partial: (token: string, lines: { itemId: string; confirmedQuantity: string }[], note?: string) =>
    api.post<PublicOrder>(`/public/orders/${token}/partial`, { lines, note }, { anonymous: true }),
  delivered: (token: string) =>
    api.post<PublicOrder>(`/public/orders/${token}/delivered`, undefined, { anonymous: true }),
  invite: (token: string) => api.get<PublicInvite>(`/public/invite/${token}`, { anonymous: true }),
  claim: (
    token: string,
    payload: {
      fullName: string
      password: string
      organizationName: string
      phone?: string
      vatNumber?: string
    },
  ) =>
    api.post<{ message: string; email: string }>(`/public/invite/${token}/claim`, payload, {
      anonymous: true,
    }),
}
